// External modules
import { css } from '@emotion/core';
import styled from '@emotion/styled';
const errorStyleOverrides = css`
  padding-left: 37px;
`;

const PrivacyTermsList = styled.ul`
  list-style: disc;
  padding-left: 37px;
  font-size: 13px;
  height: auto;
  line-height: 1.6;
  min-height: 28px;
`;

const PrivacyTermsContainer = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
`;

export { errorStyleOverrides, PrivacyTermsList, PrivacyTermsContainer };
